<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in contractListTabs"
          :key="index"
        >
          <el-form class="search-style">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item>
                  <el-select
                    v-model="params.column"
                    @change="changeQueryParamsColumn(params.column)"
                  >
                    <el-option
                      v-for="(item, index) in contractScreenCondition"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-select v-model="params.expression" v-if="params.column === 'purchaseTotal'">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="(item, index) in expressionList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                v-if="
                  params.column !== 'payType' &&
                    params.column !== 'contractState' &&
                    params.column !== 'deliverState' &&
                    params.column !== 'invoiceState' &&
                    params.column !== 'createDate'"
              >
                <el-form-item>
                  <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                v-if="
                    params.column === 'payType' ||
                    params.column === 'contractState' ||
                    params.column === 'deliverState' ||
                    params.column === 'invoiceState'
                "
              >
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="(item, index) in dataValue"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="params.column === 'createDate'">
                <el-form-item>
                  <el-date-picker
                    v-model="time"
                    style="width:100%;"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10" v-if="params.column === 'purchaseTotal'">
                <el-form-item>
                  <el-button @click="searchFor" type="primary">搜索</el-button>
                  <el-button @click="searchReset" type>重置</el-button>
                  <el-button
                    @click="onCreateContract"
                    style="float:right;"
                    type="primary"
                    plain
                  >生成合同</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="14" v-if="params.column !== 'purchaseTotal'">
                <el-form-item>
                  <el-button @click="searchFor" type="primary">搜索</el-button>
                  <el-button @click="searchReset" type>重置</el-button>
                  <el-button
                    @click="onCreateContract"
                    style="float:right;"
                    type="primary"
                    plain
                  >生成合同</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="border-box-background">
            <div class="box-table" :style="{height: tableHeight+'px'}">
              <el-table
                border
                ref="goodsDetailTable"
                :data="list"
                :max-height="tableHeight"
                tooltip-effect="dark"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
              >
                <el-table-column fixed prop="pcbNumber" label="合同编号" width="150px">
                  <template slot-scope="scope">
                    <span class="approval" @click="onEdit(scope.row)">
                      {{
                      scope.row.pcbNumber
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="supplierContractNumber"
                  show-overflow-tooltip
                  label="供应商合同编号"
                  width="130px"
                >
                  <template slot-scope="scope">
                    <div class="line-limit-length">
                      {{
                      scope.row.supplierContractNumber||'--'
                      }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="suName" show-overflow-tooltip label="供应商名称" width="120px">
                  <template slot-scope="scope">
                    <div @click="onSuName(scope.row)" class="approval line-limit-length">
                      {{
                      scope.row.suName
                      }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="payType" label="付款类型">
                  <template slot-scope="scope">{{scope.row.payType || "--" }}</template>
                </el-table-column>
                <el-table-column prop="purchaseTotal" show-overflow-tooltip label="合同金额">
                  <template slot-scope="scope">{{scope.row.purchaseTotal|priceFilterNum }}</template>
                </el-table-column>
                <el-table-column prop show-overflow-tooltip label="合同状态">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ dataList[scope.row.contractState - 1] }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="deliverStates" label="发货状态"></el-table-column>
                <el-table-column prop="actualTotal" label="已付账款">
                  <template slot-scope="scope">{{scope.row.actualTotal|priceFilterNum }}</template>
                </el-table-column>
                <el-table-column prop="paymentDue" label="已到期账款" width="100px">
                  <template slot-scope="scope">{{scope.row.paymentDue|priceFilterNum }}</template>
                </el-table-column>
                <el-table-column prop="invoiceStates" label="收票状态"></el-table-column>
                <el-table-column prop="staffCnName" label="当前负责人" width="100px">
                  <template slot-scope="scope">{{scope.row.staffCnName || "--" }}</template>
                </el-table-column>
                <el-table-column prop="orgName" label="所属部门">
                  <template slot-scope="scope">{{scope.row.orgName || "--" }}</template>
                </el-table-column>
                <el-table-column prop="createDate" label="签订时间" width="150px">
                  <template slot-scope="scope">
                    <div>{{ scope.row.createDate | dateFilter }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="updateDate" label="更新时间" width="150px">
                  <template slot-scope="scope">
                    <div>{{ scope.row.updateDate | dateFilter }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-popover
                      :open-delay="200"
                      @show="onShow(scope.row.pcbId)"
                      placement="right"
                      width="680"
                      trigger="hover"
                    >
                      <el-table :data="gridData" border max-height="480">
                        <el-table-column prop="stockupCode" label="备货编号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="contractCode" label="销售合同" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="userName" label="负责人" show-overflow-tooltip></el-table-column>
                      </el-table>
                      <el-button type="text" slot="reference">查看</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="pagination pagination-style">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import { queryAllPurchaseContractBase } from '@/api/purchase/purchasePlanList'
import { queryPurchaseTeam } from '@/api/purchase/purchaseManage'
import pagination from '@/components/pagination'
import { deepClone } from '@/util'

import { contractListTabs, contractScreenConditionList } from './util/data'
import { formatDate, resetTableLayout } from '@/util/tool'
export default {
  components: {
    pagination: pagination
  },
  mounted() {
    this.getList()
  },
  data() {
    return {
      gridData: [], // 查看列表
      isParam: true,
      isSelect: false,
      isDate: false,
      dataList: [
        '待审核',
        '审核中',
        '履行中',
        '已履行',
        '审核通过待签署',
        '已作废',
        '审核不通过',
        '审核驳回',
        '盖章审批'
      ],
      contractState: 1, // 合同状态
      activeName: '全部', // tabs选中状态
      contractListTabs: contractListTabs, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      queryParams: {}, // 搜索条件
      params: {
        column: 'suName'
      },
      paramsList: {},
      time: [],
      contractScreenCondition: contractScreenConditionList, // 合同筛选条件
      titleQuotation: '选择报价单', // 报价单弹窗名称
      expressionList: expressionList,
      dataValue: [],
      tableHeight: window.innerHeight - 380
    }
  },
  methods: {
    // 查看列表
    onShow(id) {
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      queryPurchaseTeam(this.currentPage, this.pageSize, params).then(res => {
        if (res.data.code === 200) {
          res.data.obj.records.forEach(ele => {
            if (ele.pcbId === id) {
              this.gridData = ele.purchaseOrderAllVOS
            }
          })
        }
      })
    },
    // 重置
    searchReset() {
      this.time = []
      this.params = {
        column: 'suName'
      }
      this.paramsList = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // 条件搜索
    searchFor() {
      this.paramsList = deepClone(this.params)
      if (this.time && this.time.length === 2) {
        this.paramsList.value = this.time[0]
        this.paramsList.endValue = this.time[1]
      }
      if (
        this.paramsList.value === '' ||
        this.paramsList.value === undefined ||
        this.paramsList.column === undefined
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      }
    },
    // 查询条件搜索change
    changeQueryParamsColumn(value) {
      this.time = []
      this.params = {
        column: value,
        expression: 'eq'
      }
      if (value === 'payType') {
        this.dataValue = [
          { label: '约定账期', value: '约定账期' },
          { label: '全款发货', value: '全款发货' },
          { label: '先货后款', value: '先货后款' }
        ]
      } else if (value === 'contractState') {
        this.dataValue = [
          { label: '待审核', value: '1' },
          { label: '审核中', value: '2' },
          { label: '履行中', value: '3' },
          { label: '已履行', value: '4' },
          { label: '审核通过待签署', value: '5' },
          { label: '已作废', value: '6' },
          { label: '审核不通过', value: '7' },
          // { label: '审核驳回', value: '8' },
          { label: '盖章审批', value: '9' }
        ]
      } else if (value === 'deliverState') {
        this.dataValue = [
          { label: '待发货', value: '待发货' },
          { label: '部分发货', value: '部分发货' },
          { label: '全部发货', value: '全部发货' },
          { label: '部分入库', value: '部分入库' },
          { label: '全部入库', value: '全部入库' }
        ]
      } else if (value === 'invoiceState') {
        this.dataValue = [
          { label: '未收票', value: '未收票' },
          { label: '部分收票', value: '部分收票' },
          { label: '全部收票', value: '全部收票' }
        ]
      } else if (value === 'createDate') {
      }
    },
    // 根据采购合同状态条件模糊查询
    getList() {
      this.loadingTable = true
      this.list = []
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }

      queryAllPurchaseContractBase(this.contractState, this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            resetTableLayout.call(this, this.$refs.goodsDetailTable)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // tabs切换时触发的事件
    handleClick(value) {
      this.currentPage = 1
      this.params = {
        column: 'suName'
      }
      this.paramsList = {}
      this.time = []
      if (value === '全部') {
        this.contractState = 1
      } else if (value === '待签署') {
        this.contractState = 2
      } else if (value === '履行中') {
        this.contractState = 3
      } else if (value === '已履行') {
        this.contractState = 4
      } else if (value === '已作废') {
        this.contractState = 5
      }
      this.getList()
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 生成合同
    onCreateContract() {
      this.$router.push({
        name: 'createContract',
        query: { type: '生成合同' }
      })
    },

    // 跳转供应商
    onSuName(row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 合同详情
    onEdit(row) {
      if (row.contractState === 4) {
        this.$router.push({
          name: 'contractDetails',
          query: { type: '已履行', pcbId: row.pcbId }
        })
      } else if (row.contractState === 3) {
        this.$router.push({
          name: 'contractDetails',
          query: { type: '履行中', pcbId: row.pcbId }
        })
      } else {
        let typeData = ''
        typeData = this.dataList[row.contractState - 1]
        this.$router.push({
          name: 'createContract',
          query: { type: typeData, pcbId: row.pcbId }
        })
      }
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter(time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
.number-yet,
.number-wait,
.number-yetCreate {
  bottom: 14px;
  left: 166px;
}
.number-wait {
  left: 253px;
}
.number-yetCreate {
  left: 342px;
}
</style>
